"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "40", viewBox: "0 0 38 40", className: "Icon element-image", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "defs",
            null,
            _react2.default.createElement("path", { id: "b-element-image", d: "M1 1h36v37H1z" }),
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "a-element-image" },
                _react2.default.createElement("feOffset", { dy: "1", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
                _react2.default.createElement("feGaussianBlur", { stdDeviation: ".5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0.431372549 0 0 0 0 0.431372549 0 0 0 0 0.443137255 0 0 0 0.329313859 0", "in": "shadowBlurOuter1" })
            ),
            _react2.default.createElement(
                "linearGradient",
                { x1: "0%", y1: "100%", x2: "0%", y2: "0%", id: "c-element-image" },
                _react2.default.createElement("stop", { offset: "0%", stopColor: "#B5DFF5" }),
                _react2.default.createElement("stop", { offset: "100%", stopColor: "#A6D7F4" })
            ),
            _react2.default.createElement(
                "linearGradient",
                { x1: "50%", y1: "100%", x2: "50%", y2: "0%", id: "d-element-image" },
                _react2.default.createElement("stop", { offset: "0%", stopColor: "#96BA68" }),
                _react2.default.createElement("stop", { offset: "100%", stopColor: "#7AA947" })
            ),
            _react2.default.createElement("path", { d: "M26 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", id: "f-element-image" }),
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "e-element-image" },
                _react2.default.createElement("feOffset", { "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
                _react2.default.createElement("feGaussianBlur", { stdDeviation: "2.5", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 0.992156863 0 0 0 0 0.866666667 0 0 0 0.5 0", "in": "shadowBlurOuter1" })
            )
        ),
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("use", { fill: "#000", filter: "url(#a-element-image)", xlinkHref: "#b-element-image" }),
                _react2.default.createElement("use", { fill: "#FFF", xlinkHref: "#b-element-image" })
            ),
            _react2.default.createElement("path", { d: "M38 0v39H0V0h38zM1 1v37h36V1H1z", fill: "#A5A5A5" }),
            _react2.default.createElement("path", { fill: "url(#c-element-image)", d: "M4 4h30v24H4z" }),
            _react2.default.createElement("path", { fill: "url(#d-element-image)", d: "M14 15l10 13H4z" }),
            _react2.default.createElement("path", { fill: "url(#d-element-image)", d: "M27.5 20l6.5 8H21z" }),
            _react2.default.createElement("path", { d: "M34 4v24H4V4h30zM5 5v22h28V5H5z", fill: "#000", fillOpacity: ".1" }),
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("use", { fill: "#000", filter: "url(#e-element-image)", xlinkHref: "#f-element-image" }),
                _react2.default.createElement("use", { fill: "#FFFDDE", xlinkHref: "#f-element-image" })
            )
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/element-image.js
// module id = 1796
// module chunks = 0